import { Dispatch, useCallback } from 'react';
import { useQuery } from '@tanstack/react-query';
import getNumberOfTrainingResultsRequest from '../../../lib/api/getNumberOfTrainingResults';
import sortOptions from '../../../lib/config/project/sortOptions';
import trainingFilterOptions from '../../../lib/config/project/trainingFilterOptions';
import { Sort } from '../../../lib/types';

import DesktopFilter from '../../shared/DesktopFilter';
import DesktopSort from '../../shared/DesktopSort';
import MobileFiltersAndSorts from '../../shared/MobileFiltersAndSorts';
import { isSkillup } from '../../../lib/config/project/project';
import useUpdatePotentialFilterForParam from '../../../lib/hooks/updatePotentialFilterForParam';
import { useRegion } from '../../../lib/providers/regionProvider';
import { useRouter } from 'next/router';
import { isEmpty } from 'lodash';

interface TrainingFiltersAndSortsProps {
  selectedSort: Sort;
  potentialFilters: any;
  clearAllFilters: () => void;
  setPotentialFilters: Dispatch<any>;
  setPage: Dispatch<number>;
  applySort: (sort: Sort) => void;
  seeAllResults: () => void;
  totalNumberOfResults: number;
  serverQuery: any;
}

const TrainingFiltersAndSorts: React.FC<TrainingFiltersAndSortsProps> = ({
  selectedSort,
  potentialFilters,
  setPotentialFilters,
  applySort,
  seeAllResults,
  clearAllFilters,
  totalNumberOfResults,
  serverQuery
}) => {


  const { userLocationInfo, region } = useRegion();
  const { query } = useRouter();
  // Fetches the potential number of results based on potential filters
  // selected
  const { data: potentialNumberOfResults } = useQuery(
    ['number-of-training-results', potentialFilters, userLocationInfo, query],
    () => getNumberOfTrainingResultsRequest({ ...potentialFilters, sortBy: query.sortBy, region: region?.name, coordinates: userLocationInfo?.location?.coordinates }),
  );

  const { updatePotentialFilterForParam } = useUpdatePotentialFilterForParam(potentialFilters, setPotentialFilters);
  const getDefaultValue = useCallback((paramLabel: string): string[] => {
    const arrVal = (serverQuery[paramLabel] as string)?.split('_');
    const copyOfServerQuery = { ...serverQuery };
    delete copyOfServerQuery[':region'];
    return isEmpty(copyOfServerQuery) && paramLabel == 'distance' && userLocationInfo?.zipcode ? ['50 miles'] : arrVal || []
  }, [serverQuery])


  return (
    <>
      <div className={`hidden ${isSkillup ? 'shadow-filterBar' : ''} lg:block`}>
        <div className="container py-6 mx-auto">
          <div className="flex items-center justify-between">
            <div className="flex flex-wrap items-center">
              {trainingFilterOptions.map((filter) => {
                return (
                  <div key={filter.paramLabel}>
                    <DesktopFilter
                      paramLabel={filter.paramLabel}
                      label={filter.label}
                      filterOptions={filter.options || []}
                      updatePotentialFilterForParam={
                        updatePotentialFilterForParam
                      }
                      potentialNumberOfResults={potentialNumberOfResults || 0}
                      seeAllResults={seeAllResults}
                      defaultValue={getDefaultValue(filter.paramLabel)}

                    />
                  </div>
                );
              })}
            </div>
            <div className="flex items-center">
              <p className="pr-4">Sort by:</p>
              <DesktopSort
                sortOptions={sortOptions}
                selectedSort={selectedSort}
                applySort={applySort}
              />
            </div>
          </div>
        </div>
      </div>

      <div className="block lg:hidden">
        <MobileFiltersAndSorts
          filters={trainingFilterOptions}
          sortOptions={sortOptions}
          selectedSort={selectedSort}
          potentialNumberOfResults={potentialNumberOfResults || 0}
          clearAllFilters={clearAllFilters}
          applySort={applySort}
          seeAllResults={seeAllResults}
          updatePotentialFilterForParam={updatePotentialFilterForParam}
          totalNumberOfResults={totalNumberOfResults}
        />
      </div>
    </>
  );
};

export default TrainingFiltersAndSorts;
